<template>
<div class="DetailRown ProductRown">
  <div class="LabelName">加價購</div>
  <div class="DetailRowList">
    <ul>

      <li
        v-for="(item, index) of items"
        :key="index">
        <div
          class="ProductImg img-wrapper"
          :style="{height: imgWidth+'px'}">
          <img :src="item.image_url" :alt="item.name" />
        </div>
        <div class="ProductBody">
          <div class="ProductName">{{item.name}}</div>
          <div class="ProductPrice">
            <span class="Dollor">
              <span class="sym">$</span>{{item.special_price}}
            </span>
            <span v-if="item.special_price != item.list_price" class="OrDollor">{{item.list_price}}</span>
          </div>
          <div
            v-if="item.max_qty > 0"
            class="Quantity">
            <button @click="minus(index)" class="IconMin"></button>
            <input type="text" :value="buyItems[index].qty" class="QuantityNum" />
            <button @click="plus(index)" class="IconPlus"></button>
          </div>
          <div
            v-else
            class="SaleOut">
            <a title="售完補貨中" class="Btn BtnGray">售完補貨中</a>
          </div>
        </div>
      </li>

    </ul>
  </div>
</div>
</template>

<script>
export default {
  name: "buyadditional",
  data() {
    return {
      buyItems: [],
      imgWidth: 0
    }
  },
  props: {
    items: {
      type: Array
    },
  },
  created() {
    this.buyItems = this.items.map(v => {
      return {
        aid: v.aid,
        qty: 0,
        imageUrl: v.imageUrl
      }
    });
  },
  mounted() {
    this.imgWidth = this.$el.querySelector('.img-wrapper').offsetWidth;
  },
  methods: {
    minus(idx) {
      if (this.buyItems[idx].qty === 0) {
        return
      }
      this.buyItems[idx].qty -= 1

      this.$emit('sendAdditional', this.buyItems)
    },
    plus(idx) {
      // 判斷一個主商品可選購配件數量
      if (this.buyItems[idx].qty >= this.items[idx].with_main_product_qty) {
        return
      }
      // 判斷訂單訂最大可購買數量是否超過
      if (this.buyItems[idx].qty >= this.items[idx].order_qty && this.items[idx].order_qty > 0) {
        return
      }
      // 判斷是否超過最大可販售數量
      if (this.buyItems[idx].qty >= this.items[idx].max_qty) {
        return
      }

      this.buyItems[idx].qty += 1

      this.$emit('sendAdditional', this.buyItems)
    }
  },
};
</script>

<style lang="scss" scoped>
.BtnGray {
  background-color: #e0e0e0;
  cursor: default;
}

.img-wrapper {
  position: relative;
  border-radius: 10px;
  background-color: #d8d8d8;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    position: inherit;
  }
}

.ProductBody {
  position: relative;
  padding: 0 8px;

  .ProductName {
    height: auto;
  }

  .Quantity,
  .SaleOut {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .SaleOut {
    width: 100px;
    height: 24px;

    a {
      width: 100%;
      border-radius: 5px;
      font-size: 14px;
    }
  }
}

.ProductRown {
  margin-top: 3%;
}
</style>
